import { Link } from 'react-router';
import { ArrowRight } from '@phosphor-icons/react';
import Header from './landing/Header';
import Footer from './landing/Footer';
import { usePageMeta } from '../hooks/usePageMeta';
import './LandingPage.css';

interface NotFoundPageProps {
  /** "error" when rendered as the router's error element (a page crashed). */
  variant?: 'not-found' | 'error';
}

const COPY = {
  'not-found': {
    title: 'We could not find that page',
    text: 'The link may be old or mistyped. Try the home page, or tell us what you were looking for.',
  },
  error: {
    title: 'Something went wrong on this page',
    text: 'Reloading the page usually fixes it. If it keeps happening, please let us know.',
  },
} as const;

function NotFoundPage({ variant = 'not-found' }: NotFoundPageProps) {
  const copy = COPY[variant];
  usePageMeta(`${copy.title} | EFSoft`, copy.text, '/');

  return (
    <div className="site">
      <Header />
      <main id="main-content" className="status-main" tabIndex={-1}>
        <div className="status-content">
          <p className="status-code" aria-hidden="true">
            {variant === 'not-found' ? '404' : 'Error'}
          </p>
          <h1 className="status-title">{copy.title}</h1>
          <p className="status-text">{copy.text}</p>
          <div className="status-actions">
            <Link to="/" className="btn btn--dark">
              Go to the home page
              <ArrowRight size={18} weight="bold" aria-hidden="true" />
            </Link>
            <Link to="/#contact" className="text-link">
              Contact us
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
